






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Flows extends Vue {
}
